import RestService from './RestService';

export default class MaterialsService extends RestService {
    constructor(parentService, parentId) {
        if (parentService && parentId) {
            super(`${parentService.baseUrl}/${parentId}/materials`);
        } else super('/materials');
    }
}
